import { Box, Typography } from '@mui/material'

export const DotLabel: React.FC<{ label: string; active?: boolean; muted?: boolean }> = ({
  label,
  active,
  muted,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    <Box
      sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: active ? 'primary.main' : 'grey.300' }}
    />
    <Typography variant="body2" sx={muted ? { color: 'text.secondary' } : undefined}>
      {label}
    </Typography>
  </Box>
)
